import { render, staticRenderFns } from "./print-lawsuit-paper.vue?vue&type=template&id=6f3a77f6&scoped=true&"
import script from "./print-lawsuit-paper.vue?vue&type=script&lang=js&"
export * from "./print-lawsuit-paper.vue?vue&type=script&lang=js&"
import style0 from "./print-lawsuit-paper.vue?vue&type=style&index=0&id=6f3a77f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3a77f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VProgressLinear})
